<template>
  <div class="header2">
    <div class="topBack">
      <div class="title">
        <div class="logo"></div>
        <div class="text">
          <!-- <div>企业服务代办助手</div> -->
          <!-- <div>常规办理 忘办漏办 逾期补办 一站式服务</div> -->
        </div>
      </div>
    </div>
    <div id="company" class="company common">
      <div class="name">
        <autoZoom v-if="companyInfo !== ''" :distance="1" :text="companyInfo.company"></autoZoom>
      </div>
      <div class="representative">
        <span>经营者/法定代表人：</span>
        <span>{{ companyInfo.name }}</span>
      </div>
      <div id="creditCode" class="creditCode">
        <span>统一社会信用代码/注册号：</span>
        <span>{{ companyInfo.creditcode || companyInfo.regnumber }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import autoZoom from "../components/autoZoom.vue";

export default {
  name: "", //
  data() {
    return {};
  },
  components: {
    autoZoom,
  },
  props: ["companyInfo"],
  methods: {},
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit("loaded");
    });
  },
  destroyed() {
  },
};
</script>
<style lang="less" scoped>
/* by wdl */
.common {
  background: #fff;
  box-shadow: 0px 2px 5px 0px #a7d7fb;
  width: 359px;
  margin: 15px auto 0;
  // border-radius: 5px;
  box-sizing: border-box;
  padding: 10px 10px 15px;
}

.topBack {
  background: url(../assets/images/topBack.png);
  background-size: 100% 100%;
  width: 100%;
  height: 125px;
  padding: 15px;
  box-sizing: border-box;

  .title {
    display: flex;
    align-items: center;

    .logo {
      width: 50px;
      height: 32px;
      background: url(../assets/images/logo.png);
      background-size: 100% 100%;
      margin-right: 5px;
    }

    .text {
      color: #fff;
      font-weight: bold;

      div:nth-of-type(1) {
        font-size: 15px;
      }

      div:nth-of-type(2) {
        font-size: 9px;
        background: #fff;
        color: #116bff;
        border-radius: 2px;
        padding: 1px 4px;
      }
    }
  }
}

.company {
  margin-top: -65px;
  padding: 10px 0 0;
  position: relative;
  overflow: hidden;

  .name {
    color: #116bff;
    font-size: 24px;
    text-align: center;
    font-weight: bolder;
  }

  .representative {
    padding: 10px 10px 8px;
    border-bottom: 1px solid #d3d3d3;
    font-weight: bold;
    font-size: 13px;

    span:nth-of-type(2) {
      font-weight: normal;
    }
  }

  .creditCode {
    padding: 8px 10px;
    font-weight: bold;
    font-size: 13px;

    span:nth-of-type(2) {
      font-weight: normal;
    }
  }

  .service {
    white-space: pre;
    text-align: center;
    font-size: 15px;
    color: #fff;
    font-weight: bolder;
    background: #116bff;
    padding: 5px 0;
    letter-spacing: 1px;
  }
}
</style>
